<mat-nav-list class="side-nav">
  @for (element of menuElements; track element.id) {
    @if (element.children?.length) {
      <mat-expansion-panel [class.mat-elevation-z0]="true">
        <mat-expansion-panel-header>
          <div class="menu-button">
            <mat-icon mat-list-icon>{{ element.icon }}</mat-icon><span>{{ element.title }}</span>
          </div>
        </mat-expansion-panel-header>
        <mat-nav-list>
          @for (submenu of element.children; track submenu.id) {
            <mat-list-item [routerLink]="submenu.routerLink" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact: true}" [state]="element.state">
              <div class="menu-button">
                <mat-icon>{{ submenu.icon }}</mat-icon>&nbsp;<span>{{ submenu.title }}</span>
              </div>
            </mat-list-item>
          }
        </mat-nav-list>
      </mat-expansion-panel>
    } @else {
      <mat-list-item [routerLink]="element.routerLink" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact: true}">
        <div class="menu-button">
          <mat-icon>{{ element.icon }}</mat-icon>&nbsp;<span>{{ element.title }}</span>
        </div>
      </mat-list-item>
    }
  }
</mat-nav-list>
